'use client';
import React from 'react';
import Link from 'next/link';
import { Upload, Calendar, Archive } from 'lucide-react';

export default function DashboardHeader() {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
      <div>
        <h1 className="text-2xl font-700 text-foreground">Financial Command Center</h1>
        <p className="text-sm text-muted-foreground mt-0.5">June 2026 · Personal + 3 Businesses · Private System</p>
      </div>
      <div className="flex items-center gap-2">
        <div className="flex items-center gap-2 bg-muted border border-border rounded-lg px-3 py-2 text-sm text-muted-foreground">
          <Calendar size={14} />
          <span>Jun 2026</span>
        </div>
        <Link
          href="/upload-center"
          className="flex items-center gap-2 bg-accent text-accent-foreground px-4 py-2 rounded-lg text-sm font-600 hover:bg-accent/90 transition-all duration-150 active:scale-95"
        >
          <Upload size={14} />
          Upload Docs
        </Link>
        <Link
          href="/reports"
          className="flex items-center gap-2 bg-muted border border-border text-muted-foreground px-3 py-2 rounded-lg text-sm hover:bg-surface hover:text-foreground transition-all duration-150 active:scale-95"
        >
          <Archive size={14} />
          <span className="hidden sm:block">Backup</span>
        </Link>
      </div>
    </div>
  );
}